import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, Switch } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import AppContainer from "./AppContainer";
import Dashboard from "./Pages/Dashboard";
import Invest from "./Pages/Invest";
import Agreement from "./Pages/Agreement";
import PackageHistory from "./Pages/PackageHistory";
import CmdAgree from "./Pages/CmdAgree";
import CmdPlan from "./Pages/CmdPlan";
import WalletConnect from "./Pages/WalletConnect";
import Deposit from "./Pages/Deposit";
import DepositHistory from "./Pages/DepositHistory";
import Withdrawal from "./Pages/Withdrawal";
import WithdrawalHistory from "./Pages/WithdrawalHistory";
import CompoundHistory from "./Pages/CompoundHistory";
import Settings from "./Pages/Settings";
import Kyc from "./Pages/Kyc";

// "agreement"  "ihistory"  "compoundingagreement" "icompound" "connect" "deposit" "dhistory" "withdraw" "whistory" "profile" compound

function App() {
  return (
    <GlobalState>
      {/* <ToastContainer className="foo" /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AppContainer />} />
          <Route path="/dashboards" element={<Dashboard />} />
          <Route path="/agreement" element={<Agreement />} />
          <Route path="/invest" element={<Invest />} />
          <Route path="/ihistory" element={<PackageHistory />} />
          <Route path="/compoundingagreement" element={<CmdAgree />} />
          <Route path="/compound" element={<CmdPlan />} />
          <Route path="/icompound" element={<CompoundHistory />} />

          <Route path="/connect" element={<WalletConnect />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/dhistory" element={<DepositHistory />} />
          <Route path="/withdraw" element={<Withdrawal />} />
          <Route path="/whistory" element={<WithdrawalHistory />} />
          <Route path="/profile" element={<Settings />} />
          <Route path="/kyc" element={<Kyc />} />
          {/* Add more routes as needed */}
        </Routes>
      </BrowserRouter>
    </GlobalState>
  );
}

export default App;
